import React,{ useState, useEffect } from 'react'
import { Formik, Form, Field, useFormik } from "formik";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import * as yup from "yup";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {useNavigate, useParams} from "react-router-dom"
import CircularProgress from '@mui/material/CircularProgress';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import Button from "@mui/material/Button";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ImageModal from '../../components/ImageModal';
import InvoiceUpload from '../../components/InvoiceUpload';
import MenuItem from "@mui/material/MenuItem";
import { choices } from '../utility/choices'
import { Link } from 'react-router-dom'


const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;


export const ladderSchema = yup.object().shape({
  agreement_value: yup.string().required("This is required"),
  application_id: yup.string().required("This is required"),                                   
  brokerage: yup.number().required("This is required"),
  bucket: yup.string(),
  channel_partner_name: yup.string().required("This is required"),
  collection: yup.number().required("This is required"),
  created_by: yup.string(),
  customer_id: yup.string(),
  customer_name: yup.string().required("This is required"),
  eligibility_amount: yup.number().required("This is required"),
  eligibility_status: yup.string(),
  gst: yup.string(),
  gst_amount: yup.number().required("This is required"),
  hoabl_id: yup.string().required("This is required"),
  invoice_amount: yup.number(),
  invoice_id: yup.string(),
  invoice_status: yup.string(),
  ladder_jump: yup.string(),
  launch_name: yup.string().required("This is required"),
  milestone: yup.number().required("This is required"),
  net_amount: yup.number(),
  payment_status: yup.string(),
  project_name: yup.string().required("This is required"),
  sales_region: yup.string(),
  sm_name: yup.string(),
  source_of_booking: yup.string(),
  status_cd: yup.string(),
  tds_amount: yup.number().required("This is required"),
  unique_plot_number: yup.string().required("This is required"),
  updated_by: yup.string(),
});

const TextInput = ({ field, form, ...props }) => {
  // if (field.name === "org_name") {
  //   console.log(field, form);
  // }

  return (
    <TextField
      {...field}
      {...props}
      error={
        (form?.touched[field?.name] && form?.errors[field?.name]) ||
        (form?.errors[field?.name] && form?.submitCount > 0)
      }
      helperText={form?.touched[field?.name] && form?.errors[field?.name]}
    />
  );
};

const SelectInput = ({ field, form, ...props }) => {
  // if (field.name === "org_name") {
  //   console.log(field, form);
  // }

  return (
    <input
      {...field}
      {...props}
      error={
        (form?.touched[field?.name] && form?.errors[field?.name]) ||
        (form?.errors[field?.name] && form?.submitCount > 0)
      }
      helperText={form?.touched[field?.name] && form?.errors[field?.name]}
      type='select'
      className="select"
    >
      {props.children}
    </input>
  );
};

const CustomButton = ({ field, form, ...props }) => {
  return (
    <button className="registrationbutton" {...field} {...props} >
      {props.children}
    </button>
  );
};

function EditLadderIncentive() {
  const [isloading, setIsloading] = useState(false);
  const [initialValue, setInitialValue] = useState({})
  const navigate = useNavigate();
  let {id} = useParams()

  let authToken;
  try{
    authToken = JSON.parse(localStorage.getItem('EMPLOYEE-AUTH'))
  }catch(err){
    authToken = null
  }

  useEffect(() => {
    fetchDataById()

    return () => {
      
    }
  }, [])

  const fetchDataById = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer" +" "+ authToken.token);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(process.env.REACT_APP_BASE_URL+"/ladder-incentive-details/"+id, requestOptions)
      .then(response => response.json())
      .then(result => {
        // console.log(result)
        setInitialValue(result)
        // setRows(result.channel_partner)
      })
      .catch(error => console.log('error', error));
  }

  const handleSubmit = async (values, actions, errors) => {
    setIsloading(true)
    // console.log(values, actions, errors);

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer "+authToken.token);

    var raw = JSON.stringify({
      agreement_value: values.agreement_value,
      application_id: values.application_id,
      brokerage: values.brokerage,
      bucket: values.bucket,
      channel_partner_name: values.channel_partner_name,
      collection: values.collection,
      created_by: values.created_by,
      customer_id: values.customer_id,
      customer_name: values.customer_name,
      eligibility_amount: values.eligibility_amount,
      eligibility_status: values.eligibility_status,
      account_eligibility_status: values.account_eligibility_status,
      gst: values.gst,
      gst_amount: values.gst_amount,
      hoabl_id: values.hoabl_id,
      invoice_amount: values.invoice_amount,
      invoice_id: values.invoice_id,
      invoice_status: values.invoice_status,
      ladder_jump: values.ladder_jump,
      launch_name: values.launch_name,
      milestone: values.milestone,
      net_amount: values.net_amount,
      payment_status: values.payment_status,
      project_name: values.project_name,
      sales_region: values.sales_region,
      sm_name: values.sm_name,
      source_of_booking: values.source_of_booking,
      status_cd: values.status_cd,
      tds_amount: values.tds_amount,
      unique_plot_number: values.unique_plot_number,
    });

    var requestOptions = {
      method: 'PATCH',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(process.env.REACT_APP_BASE_URL+"/ladder-incentive-details/"+id, requestOptions)
      .then(result => {
        // console.log(result.status)
        if (result.status%400<10){
          NotificationManager.error('Not authorised to edit the data', 'Error', 6000);
        }
        setIsloading(false)
        navigate("/admin/ladder-incentive")
      })
      .catch(error => {
        console.log('error', error)
        NotificationManager.error('Something went wrong', 'Error', 6000);
        setIsloading(false)
      });

  }

  return (
    <div>
      {initialValue.id && (<Formik
        initialValues={{...initialValue}}
        validationSchema={ladderSchema}
        onSubmit={handleSubmit}
      >
        {({ touched, errors, values, submitCount, setFieldValue, handleSubmit,submitForm }) => (
          <Form  >
            <Grid container spacing={2}>
              <Grid item md={12} xs={12}>
                <div style={{ padding: "1rem", display:'flex', justifyContent:'space-between' }}>
                  <h4 style={{ font: "Jost" }}>Edit Ladder Incentive</h4>
                  <Button className="registrationbutton"  variant="contained" startIcon={<ArrowBackIosNewIcon />} onClick={() => navigate(-1) } >Back</Button>
                </div>
              </Grid>
              <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="agreement_value"
                  label="Agreement Value*"
                  fullWidth
                  component={TextInput}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="application_id"
                  label="Application Id*"
                  fullWidth
                  component={TextInput}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="brokerage"
                  label="Brokerage"
                  required
                  fullWidth
                  component={TextInput}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="bucket"
                  label="Bucket"
                  fullWidth
                  component={TextInput}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="channel_partner_name"
                  label="Channel Partner Name*"
                  fullWidth
                  component={TextInput}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="collection"
                  label="Collection (%)"
                  fullWidth
                  component={TextInput}
                />
              </Grid>
              {/* <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="created_by"
                  label="Created By"
                  fullWidth
                  component={TextInput}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="customer_id"
                  label="Customer Id"
                  fullWidth
                  component={TextInput}
                />
              </Grid> */}
              <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="customer_name"
                  label="Customer Name*"
                  fullWidth
                  component={TextInput}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="eligibility_amount"
                  label="Eligibility Amount*"
                  fullWidth
                  component={TextInput}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                {/* <Field
                  type="text"
                  name="eligibility_status"
                  label="eligibility_status"
                  fullWidth
                  component={TextInput}
                /> */}
                <Field
                  name="eligibility_status"
                  label="Eligibility Status"
                  required
                  fullWidth
                  select={true}
                  SelectProps={{
                    onClose: () => {
                      setTimeout(() => {
                        document.activeElement.blur();
                      }, 0);
                    },
                  }}
                  onChange={(e) => {
                    setFieldValue("eligibility_status",e.target.value)
                  }}
                  component={TextInput}
                >
                  {choices.eligibility_status.map(item => <MenuItem key={item.id} value={item.value}>{item.value}</MenuItem>)}
                </Field>
              </Grid>
              <Grid item md={6} xs={12}>
                <Field
                  name="account_eligibility_status"
                  label="Accounts Approved"
                  fullWidth
                  required
                  select={true}
                  SelectProps={{
                    onClose: () => {
                      setTimeout(() => {
                        document.activeElement.blur();
                      }, 0);
                    },
                  }}
                  onChange={(e) => {
                    setFieldValue("account_eligibility_status",e.target.value)
                  }}
                  component={TextInput}
                >
                  {choices.eligibility_status.map(item => <MenuItem key={item.id} value={item.value}>{item.value}</MenuItem>)}
                </Field>
              </Grid>
              <Grid item md={6} xs={12}>
                {/* <Field
                  type="text"
                  name="gst"
                  label="gst"
                  fullWidth
                  component={TextInput}
                /> */}
                <Field
                  name="gst"
                  label="GST Type"
                  required
                  fullWidth
                  select={true}
                  SelectProps={{
                    onClose: () => {
                      setTimeout(() => {
                        document.activeElement.blur();
                      }, 0);
                    },
                  }}
                  onChange={(e) => {
                    setFieldValue("gst",e.target.value)
                  }}
                  component={TextInput}
                >
                  {choices.gst.map(item => <MenuItem key={item.id} value={item.value}>{item.value}</MenuItem>)}
                </Field>
              </Grid>
              <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="gst_amount"
                  label="Gst Amount"
                  fullWidth
                  component={TextInput}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="hoabl_id"
                  label="Hoabl Id*"
                  fullWidth
                  component={TextInput}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="invoice_amount"
                  label="Invoice Amount"
                  fullWidth
                  component={TextInput}
                />
              </Grid>
              {/* <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="invoice_id"
                  label="invoice_id"
                  fullWidth
                  component={TextInput}
                />
              </Grid> */}
              {/* <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="invoice_status"
                  label="Invoice Status"
                  fullWidth
                  component={TextInput}
                />
              </Grid> */}
              <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="ladder_jump"
                  label="Ladder Jump"
                  fullWidth
                  component={TextInput}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="launch_name"
                  label="Launch Name*"
                  fullWidth
                  component={TextInput}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="milestone"
                  label="Milestone"
                  fullWidth
                  component={TextInput}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="net_amount"
                  label="Net Amount"
                  fullWidth
                  component={TextInput}
                />
              </Grid>
              {/* <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="payment_status"
                  label="Payment Status"
                  fullWidth
                  component={TextInput}
                />
              </Grid> */}
              <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="project_name"
                  label="project_name*"
                  fullWidth
                  component={TextInput}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="sales_region"
                  label="Sales Region"
                  fullWidth
                  component={TextInput}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="sm_name"
                  label="Sm Name"
                  fullWidth
                  component={TextInput}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="source_of_booking"
                  label="Source of Booking"
                  fullWidth
                  component={TextInput}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="status_cd"
                  label="Status Cd"
                  fullWidth
                  component={TextInput}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="tds_amount"
                  label="Tds Amount"
                  fullWidth
                  component={TextInput}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Field
                  type="text"
                  name="unique_plot_number"
                  label="Unique Plot Number*"
                  fullWidth
                  component={TextInput}
                />
              </Grid>
              {!values.invoice_id ? (
                <>
                  <Grid item md={3} xs={5}>
                    <div style={{ padding: "0.5rem 0 0 0" }}>
                      <p>Invoice Upload:</p>
                    </div>
                  </Grid>
                  <Grid item md={1} xs={2}>
                    <div style={{ padding: "0.5rem 0 0 0" }}>
                      {values.invoice_url && <ImageModal url={values.invoice_url} ls_token_key={"EMPLOYEE-AUTH"}/>}
                    </div>
                  </Grid>
                  <Grid item md={1} xs={2}>
                    <div style={{ padding: "0.5rem 0 0 0" }}>
                      <InvoiceUpload ls_token_key="EMPLOYEE-AUTH" type="ladder_incentives" type_id={[values.id]} hoabl_id={values.hoabl_id} setValue={(inv_id) => setFieldValue("invoice_id",inv_id)} />
                      {/* <label for="invoice_upload">
                        <CloudUploadIcon />
                      </label>
                      <input
                        type="file"
                        accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps"
                        id="invoice_upload"
                        name="invoice_upload"
                        onChange={(event) => {
                          // console.log(event.target.files[0])
                          setFieldValue(
                            "invoice_upload",
                            event.target.files[0]
                          );
                        }}
                        hidden
                      /> */}
                    </div>
                  </Grid>
                </>
              ):(
                <Grid item md={3} xs={5}>
                  <Link to={`/admin/invoices/edit/${values.invoice_id}`} style={{all:'unset'}}>
                    <Button className="tablebutton">Invoice Details</Button>
                  </Link>
                </Grid>
              )}
              
              <Grid item md={12} xs={12}>
                <Field id="submitEdit" style={{width:'100%'}} name="submitEdit" type="submit"  component={CustomButton}>
                    {isloading ? <CircularProgress sx={{color:"#FFFFFF"}} size="1.5rem"/>:"Edit"}
                </Field>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>)}
    </div>
  )
}

export default EditLadderIncentive